<div class="report-container">
    <div class="column">
       <div class="section">
        <div class="section-title">TLR Status Reports
            </div>
            <div class="link-list">
                <a routerLink="/tlr-status-reports/status-report/status">Status Report</a>
                <router-outlet></router-outlet>
                <div class="description">Provides a status on all TLR's</div>
                <a routerLink="/tlr-status-reports/status-report/installed">Installed TLR Status Report</a>
                <div class="description">Provides a status on all Installed TLR's.</div>
                <a routerLink="/tlr-status-reports/removed-report">Removed TLR Status Report:</a>
                <div class="description">Provides a list of all TLR's that have been Removed.</div>
                <a routerLink="/tlr-breakdown-report">TLR Break-Down by Section Report:</a>
                <div class="description">Provides a list of all Installed TLR's that show a comparison between 'Installed', 'Engineered', 'Beyond Due Date', 'OTR', 'OTR Overdue'.</div>
                <a routerLink="/tlr-beyond-date-report">TLR's Beyond Due Date Report:</a>
                <div class="description">Provides a list of all TLR's that have a Permanent Repair Date that will be coming due, or is past due. It also indicates if a Permanent Repair Date is NOT specified.</div>
                <a routerLink="/tlr-status-reports/orphan-report/steamBuster">Steam Busters Report:</a>
                <div class="description">Provides a list of all Installed Steam TLR’s that are Available On-The-Run (OTR).</div>
                <a routerLink="/tlr-status-reports/orphan-report/abandoned">Abandoned/Out of Service Report:</a>
                <div class="description">Provides a list of TLRs on Abandoned/Out of Service Equipment.</div>
                <a routerLink="/tlr-status-reports/shutDown-report">Shutdown Report:</a>
                <div class="description">Provides a list of all Installed TLR's with pertinent shutdown information.</div>
                <a routerLink="/tlr-status-reports/orphan-report/onrun">TLR's On The Run Report:</a>
                <div class="description">Provides a list of On-The-Run (OTR) TLR’s.</div>
                <a routerLink="/tlr-status-reports/orphan-report/orphan">TLR Orphan Report:</a>
                <div class="description">Provides a list of Orphan TLR’s.</div>
            </div>
        </div>

        <div class="section">
            <div class="section-header">
                Management Reports
                </div>
                <div class="link-list">
                    <a routerLink="/management-report/tlr-management-report">TLR Management Report:</a>
                    <div class="description">Provides an overall break down of where the TLR's fall into categories.</div>
                    <a routerLink="/management-report/tlr-stewardship-report">TLR Stewardship Report:</a>
                    <div class="description">Provides a list of TLR items that need Stewardship work performed.</div>
                    <a routerLink="/management-report/tlr-aging-report">TLR Aging Report:</a>
                    <div class="description">Provides a list of TLR's by Section by years Installed.</div>
                    <a routerLink="/management-report/tlr-greater-than-five-year-report">TLR’s Greater Than 5 Years Report:</a>
                    <div class="description">Provides a list of all Installed TLR’s that are older than 5 years with KMS/MOC Reference Numbers.</div>
                    <a routerLink="/management-report/tlr-historical-data-report">TLR Historical Data Report:</a>
                    <div class="description">Provides a chart of the Refinery historical data over the years of Installed Repaired and Trending TLR's.</div>
                    </div>
            </div>

            <div class="section">
                <div class="section-header">
                    Integrity Threat Reports
                    </div>
                    <div class="link-list">
                        <a routerLink="/integrity-threat-reports/entire-refinery-itr-tlr-report">Entire Refinery ITR/TLR Report:</a>
                        <div class="description">Provides a Management Summary Report of ITR’s pulled from Meridium, ITR's with Maximo Work Orders, and ITR’s that have TLR attributes with Maximo Work Orders that are Associated.</div>
                        <a routerLink="/integrity-threat-reports/refinery-itr-oppis-report">Refinery ITR OPPIS Report:</a>
                        <div class="description">Provides a Detailed Report of ITR’s on OPPIS (Off-Plot) Lines.</div>
                        <a routerLink="/integrity-threat-reports/oppis-line-detail-report">OPPIS Line Detail Report:</a>
                        <div class="description">Provides a Detailed Report of all Installed TLR’s with ITR’s Associated on a Specific OPPIS (Off-Plot) Line.</div>
                        </div>
                </div>

                <div class="section">
                    <div class="section-header">
                        Air Compliance Reports
                        </div>
                        <div class="link-list">
                            <a routerLink="/app-find-tlr-blue-tag-number/blue-tag">Find TLR Given Blue Tag Number:</a>
                            <div class="description">Provides a list of TLR’s given a Blue Tag Number.</div>
                            <a routerLink="/ldar-fugitive-report/report">LDAR Fugitive Emission Report:</a>
                            <div class="description">Provides a Rule 1173 Fugitive Emission Report on Installed TLR's.</div>
                            </div>
                    </div>

        </div>
        <div class="column">
            <div class="section">
                <div class="section-header">Inspector/OA/Engineer Reports
                    </div>
                    <div class="link-list">
                        <a routerLink="/find-tlr/work-order-component">Find TLR's Given a Work Order:</a>
                        <div class="description">Provides a list of all TLR’s given a Work Order.</div>
                        <a routerLink="/missing-permanent-repair-report/date-report">Missing Permanent Repair Date Report:</a>
                        <div class="description">Provides a list of Installed TLR’s that are missing a Permanent Repair Date.</div>
                        <a routerLink="/inspection-look-ahead/report-component">Inspections Look Ahead Report:</a>
                        <div class="description">Provides a list of Installed TLR’s that are coming due with the Permanent Repair Date selected.</div>
                        <a routerLink="/inspection-cai-report/report-component">Inspector User ID Report:</a>
                        <div class="description">Provides a list of all TLR's that have an Inspector's User ID in the Inspections record.</div>
                        <a routerLink="/assigned-to-cai-component/cai-component">Assigned to User ID Report:</a>
                        <div class="description">Provides a list of TLR's where the User ID is found in the Operations, Inspections, OA or Engineering data.</div>
                        <a routerLink="/inspection-installed/report-component">Inspected/Installed Report:</a>
                        <div class="description">Provides a list of all Installed TLR's that show a comparison with which TLR's have been "inspected" versus "installed".</div>
                        <a routerLink="/engineered-installed/report-component">Engineered/Installed Report:</a>
                        <div class="description">Provides a list of all Installed TLR's that show a comparison with which TLR's have been "engineered" versus "installed".</div>
                        <a routerLink="/permannent-repair/report-component">Permanent Repair Date within 90 Days without an Active Maximo WO:</a>
                        <div class="description">Provides a list of Installed TLR’s that have a Permanent Repair Date in the next 90 Days and have no Active Maximo Work Order Associated.</div>
                        <a routerLink="/inspector-validation/required-component">Inspector Validation Required – Work Orders Completed Report:</a>
                        <div class="description">Provides a list of Installed TLR’s that have all Maximo Work Orders completed and needs the Inspector to mark this TLR as Repaired.</div>
                        <a routerLink="/inspector-installedtlr/report-component">Inspector Installed TLR Report:</a>
                        <div class="description">Provides a list of Installed TLR’s with an Inspector determined search criteria for locating their TLR's.</div>
                    </div>
                </div>

                <div class="section">
                    <div class="section-header">
                            URB Reports
                        </div>
                        <div class="link-list">
                            <a routerLink="/urb-reports/urb-report-search">URB TLR Look Ahead Report:</a>
                            <div class="description">Provides an aggregated report of all TLR's and their Permanent Repair Dates in the future.</div>
                            </div>
                    </div>


                    <div class="section">
                        <div class="section-header">
                            OERI Validation Reports
                            </div>
                            <div class="main-box">
                            <span>OERI Last Called TLR: 12/17/2019 11:37:27 PM</span>
                            <span>Open TLR's Provided to OERI: 534</span>
                            <span>TLR's Removed in the Last 30 Days: 4</span>
                            </div>
                            <div class="link-list">
                                <a routerLink="/match-oeri-open-tlr">Match OERI Installed TLR's:</a>
                                <div class="description">Provides a list of Installed.</div>
                                <a routerLink="/over-due-tlr-details-report">Overdue TLR Details Report:</a>
                                <div class="description">Is used along with the OERI URB PDF Report to validate that OERI is working properly.</div>
                                <a routerLink="/discovered-past-reports">Discovered Past 60 Days Report:</a>
                                <div class="description">Is used along with the OERI URB PDF Report to validate that OERI is working properly.</div>
                                <a routerLink="/orphaned-tlr-report">Orphaned TLR Report:</a>
                                <div class="description">Provides a list of Orphaned TLR’s.</div>    
                            </div>
                        </div>


                        <div class="section">
                            <div class="section-header">
                                Compliance Reports
                                </div>
                                <div class="link-list">
                                    <a routerLink="/compliance-reports/psm-group">Compliance Report for the PSM Group:</a>
                                    <div class="description">Provides a spreadsheet of all Installed and Repaired TLR's in the refinery selectable by Division, Section, Plant with corresponding TLR detailed pages for each TLR.</div>
                                    <a routerLink="/compliance-reports/cal-arp-report">CalARP Report:</a>
                                    <div class="description">Provides a list of Installed TLR’s that meet the CalARP Report TLR requirements to be listed on the report.</div>
                                    <a routerLink="/compliance-reports/compliance-v-and-v-report">TLR Compliance V&V Report:</a>
                                    <div class="description">Provides a list of TLR’s that are out of Compliance with MFG-515.</div>
                                    <a routerLink="/compliance-reports/fei-lookahead-report">FEI Lookahead Report:</a>
                                    <div class="description">Provides a list of Total TLR’s Installed to feed the FEI Lookahead Report.</div>    
                                    <a routerLink="/compliance-reports/tlr-surveillance-report">TLR Surveillance Report:</a>
                                    <div class="description">Provides a list of TLR’s and their Surveillance criteria.</div>    
                                </div>
                            </div>


                            <div class="section">
                                <div class="section-header">
                                    Maximo Reports *
                                    </div>
                                    <div class="link-list">
                                        <a routerLink="/maximo-data/intergrity">Maximo Data Integrity Check Report:</a>
                                        <div class="description">Provides a list of data entry Errors that are preventing Maximo data from entering the TLR database.</div>
                                        <a routerLink="/invalid-division/plant-report">Invalid Division/Section/Plant Report:</a>
                                        <div class="description">Provides a list of Work Orders with Errors that are preventing Maximo data from entering the TLR database.</div>
                                    </div>
                                </div>
            </div>

</div>